/* global groots */

( function( global ) { // eslint-disable-line
    var pluginName = 'expander';

    var config = {
        trigger: '[expander-trigger]',
        target: '[expander-target]',
        pane: '[expander-pane]',
        closeAllOnToggle: false
    }

    if (Array.prototype.contains === undefined) {
        // attach the .contains method to Array's prototype to call it on any array
        Array.prototype.contains = function (thing) {
            if (!this) return false; // if the other array is a falsy value, return false
            var result = false; // start by assuming the array doesn't contain the thing
            for (var i = 0, l=this.length; i < l; i++) {
                if (this[i] instanceof Array) { // if anything in the array is the thing then change our mind from before
                    if (this[i].equals(thing)) result = true;
                } else if (this[i]===thing) result = true;
            }
            return result; //return the decision
        }
    }

    // Constructor
    function expander( selector, options ) {
        // Merge defaults with user's settings
        this.config = global.methods.objectAssign(config, options);

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Get elements
        this.triggers = this.selector.querySelectorAll(this.config.trigger);
        this.targets = this.selector.querySelectorAll(this.config.target);
        this.panes = this.selector.querySelectorAll(this.config.pane);
        this.heights = [];

        // Retrieve plugin custom parameters
        this.params = this.selector.getAttribute('expander').split(' ');

        this.init();
    }

    expander.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            global.methods.toggleAttributeValue(this.selector, 'expander', 'processing');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): processing');

            this.warning();
            this.calculateHeights();
            this.moveTargets();

            // binding
            var arr = [
                'handleClick',
                'resizeHandler'
            ];

            for (var i = 0, len = arr.length; i < len; i++) {
                var method = arr[i];
                this[method] = this[method].bind(this);
            }

            // addEventListener
            window.addEventListener('resize', global.methods.debounce(this.resizeHandler, 150));
            var triggers = this.triggers;
            for (var t = 0; t < triggers.length; t++) {
                var trigger = triggers[t];
                trigger.addEventListener('click', this.handleClick);
            }

            global.methods.removeAttributeValue(this.selector, 'expander', 'processing');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): end processing');

            // ready
            this.ready = true;
            global.methods.toggleAttributeValue(this.selector, 'expander', 'ready');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): ready');
        }
    };

    // Destroy - remove listeners to prevent from memory leak
    expander.prototype.destroy = function destroy() {
        if (groots.verbose) console.log(pluginName + ': destroyed');
        global.methods.removeAttributeValue(this.selector, 'expander', 'ready');

        // removeEventListener
        window.removeEventListener('resize', this.resizeHandler);
        var triggers = this.triggers;
        for (var t = 0; t < triggers.length; t++) {
            var trigger = triggers[t];
            trigger.removeEventListener('click', this.handleClick);
        }

        // clear
        this.heights = [];

        var targets = this.targets;
        for (var i = 0; i < targets.length; i++) {
            var target = targets[i];
            target.removeAttribute('style');
        }
    };

    // TODO: if triggers, targets and panes have same length
    expander.prototype.warning = function warning() {
        if (groots.verbose) console.log(pluginName + ': check warning');

        if (this.triggers.length === 0) {
            console.warn(pluginName + ': You\'re not providing any triggers');
        }

        if (this.targets.length === 0) {
            console.warn(pluginName + ': You\'re not providing any targets');
        }

        if (this.panes.length === 0) {
            console.warn(pluginName + ': You\'re not providing any panels');
        }
    };

    expander.prototype.calculateHeights = function calculateHeights() {
        if (groots.verbose) console.log(pluginName + ': calculateHeights');

        var targets = this.targets;
        for (var i = 0; i < targets.length; i++) {
            var targetHeight = targets[i].offsetHeight;
            this.heights.push(targetHeight);
        }
    };

    expander.prototype.moveTargets = function moveTargets() {
        if (groots.verbose) console.log(pluginName + ': moveTargets');

        var panes = this.panes;
        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            var target = pane.querySelector(this.config.target);
            target.style.height = 0;
            if (pane.classList.contains('is-open')) {
                target.style.height = this.heights[i] + 'px';
            }
        }
    };

    expander.prototype.handleClick = function handleClick(event) {
        if (groots.verbose) console.log(pluginName + ': click');

        var pane = global.methods.closest(this.config.pane, event.target);

        if (this.config.closeAllOnToggle) {
            this.closeAll();
        }

        pane.classList.toggle('is-open');
        this.moveTargets();
    };

    expander.prototype.resizeHandler = function resizeHandler() {
        if (groots.verbose) console.log(pluginName + ' debounce');

        var targets = this.targets;
        for (var i = 0; i < targets.length; i++) {
            var target = targets[i];
            target.removeAttribute('style');
        }

        this.heights = []; // clear heights
        this.calculateHeights();
        this.moveTargets();
    };

    expander.prototype.closeAll = function closeAll() {
        var panes = this.panes;
        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            pane.classList.remove('is-open');
        }
    };

    // jQuery wrapper, if available
    if (window.jQuery) {
        $.fn[pluginName] = function (options) {
            options = options || config;
            return this.each(function() {
                // add plugin to element data
                if (!$.data(this, pluginName) ) $.data(this, pluginName, new expander(this, options));
            });
        };
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = expander;
    // Export to Browser
    else global[pluginName] = expander; // eslint-disable-line

    // app instantiation
    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        if ($container.find('[expander]').length) {
            window.groots.expander = { instances: {} };
            var all = $container.find('[expander]');
            var index = -1;
            while (all[++index])
                global.expander.instances[index] = new expander(all[index]);
        }
    });

}( window.groots ));
